











































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { statisticDetailTimes } from '@/constants/type-helper';
import { namespace } from 'vuex-class';
import { openUrl } from '@/util';
import { AcgnFormTitle } from '@/components/';
import AcgnPopFiledModify from '../pop-field-modify.vue';
import AcgnPopFiledHistory from '../pop-field-history.vue';
import {
  AcgnTable,
} from '@acgn/herm/src/ui';
import { complexClone } from '@acgn/herm/src/util/serialize';

const StatisticNorAction = namespace('desk/statisticNor').Action;
const StatisticAction = namespace('desk/statistic').Action;
import { DataTypesMixin } from '@/mixins';

@Component({
  components: {
    AcgnTable,
    AcgnFormTitle,
    AcgnPopFiledModify,
    AcgnPopFiledHistory
  },
  mixins: [ DataTypesMixin ]
})

/**
 * 任务情况-创作方
 */
export default class AcgnTaskNorDetail extends Vue {

  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: null }) public userId: number | null; // 成员id
  @Prop({ default: '' }) public exportCode: string; // 导出权限码
  @Prop({ default: false }) public isShowModify: boolean; // 显示修改按钮
  // 1：创作方统计，2：管理方统计
  @Prop({ default: 1 }) public type: number; // 用于区分请求数据接口

  @StatisticNorAction private getTaskCycleDetail: any;
  @StatisticAction private getTaskCycleAdminDetail: any;
  @StatisticAction private reviseCellnum: any;

  private apiKey: any = {
    1: 'getTaskCycleDetail',
    2: 'getTaskCycleAdminDetail'
  };

  private selectOpts: any = statisticDetailTimes;
  private selectType: number = 2;
  private isInit: boolean = false;
  private statusType: any = null;
  private dataType: number = (this as any).type === 2 ? 4 : 0;
  private options: any = {
    apiType: 1,
    userId: (this as any).userId,
    cycle_type: this.dataType > 0 ? 3 : this.selectType,
    project_id: (this as any).comicId
  };

  private statuss = [{
    id: 2,
    name: '审批通过'
  }];
  private popData: any = {};
  private visible: boolean = false;

  private tableConfig: any = {
    columns: [
      {
        label: '环节',
        prop: 'time_slot',
        width: 200
      },
      {
        label: '环节数',
        prop: 'cnt'
      },
      {
        label: '件数',
        prop: 'num',
        showOverflowTooltip: false,
        render: (h: any, { row }: any) => (this as any).renderField(row)
      },
      {
        label: '单价',
        prop: 'price',
      },
      {
        label: '总价',
        render: (h: any, { row }: any) => (this as any).renderTotalPrice(row)
      }
    ],
    data: []
  };

  private pageConfig: any = {}; // 分页数据
  // table组件获取数据更新数据接口
  private async initSearh() {
    const { tableConfig, pageConfig } = this;
    const options = this.getSearchOptions();
    let result: any = {colnames: [], list: []};
    try {
      const res = await (this as any)[this.apiKey[this.type]](options);
      result = res.result;
    } catch (error) {
      this.$message.error('请求失败');
    }
    this.setListColumn(result.colnames, tableConfig);
    tableConfig.data = result.list;
  }

  private getSearchOptions() {
    return {
      type: this.selectType,
      project_id: this.comicId,
      user_id: this.userId,
      status: this.statusType,
      order: this.dataType > 0 ? 1 : 2,
      data_type: this.dataType
    };
  }

  private setListColumn(colnames: any, config: any) {
    if (this.isInit) {
      return;
    }
    this.isInit = true;
    colnames.map((item: any) => {
      config.columns.push({
        label: item,
        prop: item
      });
    });
  }

  private renderField(row: any) {
    const numValue = row.num[0];
    let numDiff = row.num[1];
    const data = { title: row.time_slot, field: '件数', value: numDiff, originValue: numValue };
    const classStyle = numDiff ? 'color--danger' : '';
    numDiff = numDiff ? numDiff : 0;
    return (
      <div>
        <span class={classStyle}>{numValue + numDiff}</span>
        {this.isShowModify ? <span
          class="el-icon-edit color--primary"
          style="margin-left:4px;vertical-align: middle;cursor: pointer;"
          onClick={() => this.doCli(data)}
        >
        </span> : ''
        }
      </div>
    );
  }

  private renderTotalPrice(row: any) {
    const {num, price = 0} = row;
    let total = num * price || 0;
    if (Array.isArray(num)) {
      const totalNum = num[0] + (num[1] || 0);
      total = totalNum * price;
    }
    return total.toFixed(2);
  }

  private doCli(data: any) {
    this.visible = true;
    this.popData = data;
  }

  private async sumbit(data: any) {
    const dataClone: any = {};
    dataClone.time_slot = data.title;
    dataClone.described = data.field;
    dataClone.revised_num = data.value;
    dataClone.described = data.remark;
    dataClone.revised_extra = data.revised_extra;
    dataClone.user_id = this.userId;
    dataClone.cycle_type = this.selectType;
    dataClone.project_id = this.comicId;
    try {
      await this.reviseCellnum(dataClone);
    } catch (ex) {
      this.$message.error(this.$language.error);
      return true;
    }
    this.$message.success('修改成功');
    this.initSearh();
    return false;
  }

  private statusChange() {
    this.initSearh();
  }

  private selectChange() {
    this.options.cycle_type = this.dataType > 0 ? 3 : this.selectType; // 解决历史记录问题
    this.initSearh();
  }

  private exportExcel() {
    if (this.type === 1) {
      openUrl('/api/v1/workbench/taskcycle?export=1', this.getSearchOptions());
    } else {
      openUrl('/api/v1/workbench/taskcycleofadmin?export=1', this.getSearchOptions());
    }
  }
}
